import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  RequestType: localStorage.requestType || 'Loadout',
}

export const requestTypeSlice = createSlice({
  name: 'requestType',
  initialState,
  reducers: {
    setRequestType: (state, action) => {
      state.RequestType = action.payload.RequestType
    },
  },
})

export const { setRequestType } = requestTypeSlice.actions

export default requestTypeSlice.reducer